/*
  Ruma Match - meyve cizimleri (cizgi film tarzi, SVG).

  Ortak kurallar (her meyvede ayni):
  - Isik sol ustten gelir.
  - Dis kontur kalin, ic cizgiler ince; kontur golge tarafinda (sag alt) biraz kalinlasir.
  - Govde golgelemesi 4 ton: yansima isigi (kenar), golge, ana renk, isik + net bir parlama.
  - Sap / yaprak birlesimleri bir dugum ya da ortusme ile kapatilir, bosluk kalmaz.

  Her meyve 200x200'luk bir <symbol> olarak uretilir: <use href="#rm-m-ananas">.
  Yeni meyve eklemek: asagidaki MEYVELER listesine bir fonksiyon + ayar dosyasina adi.
*/
(function (kok) {
  'use strict';

  var K = '#3B2314';     // dis kontur
  var IC = '#4A2A12';    // ic cizgi
  var ISIK = [-0.68, -0.74];
  var sayac = 0, ekDefs = '';

  function yeniId(on) { return 'rm' + on + (sayac++); }
  function f(n) { return (Math.round(n * 10) / 10).toString(); }
  function rastgele(tohum) {
    var s = tohum >>> 0;
    return function () {
      s = (s + 0x6D2B79F5) >>> 0;
      var t = Math.imul(s ^ (s >>> 15), s | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  // ---------- geometri ----------

  // Kubik bezier segmentlerini noktalara cevirir: [p0, c1, c2, p1, c1, c2, p2, ...]
  function kubik(p, adim) {
    var out = [];
    for (var i = 0; i + 3 < p.length; i += 3) {
      var a = p[i], b = p[i + 1], c = p[i + 2], d = p[i + 3];
      for (var k = i ? 1 : 0; k <= adim; k++) {
        var t = k / adim, u = 1 - t;
        out.push([
          u * u * u * a[0] + 3 * u * u * t * b[0] + 3 * u * t * t * c[0] + t * t * t * d[0],
          u * u * u * a[1] + 3 * u * u * t * b[1] + 3 * u * t * t * c[1] + t * t * t * d[1]
        ]);
      }
    }
    return out;
  }

  // Dondur (derece, saat yonu), olcekle, tasi. ox/oy: donme merkezi (yerel)
  function donustur(n, o) {
    var a = (o.aci || 0) * Math.PI / 180, c = Math.cos(a), s = Math.sin(a), k = o.olcek || 1;
    return n.map(function (p) {
      var x = (p[0] - (o.ox || 0)) * k, y = (p[1] - (o.oy || 0)) * k;
      return [x * c - y * s + (o.x || 0), x * s + y * c + (o.y || 0)];
    });
  }
  function yon(o) { // yerel "yukari" vektorunun donmus hali
    var a = (o.aci || 0) * Math.PI / 180;
    return [Math.sin(a), -Math.cos(a)];
  }

  // Noktalardan yumusak (Catmull-Rom) yol
  function yol(n, kapali) {
    var m = n.length, s = 'M' + f(n[0][0]) + ' ' + f(n[0][1]);
    var son = kapali ? m : m - 1;
    for (var i = 0; i < son; i++) {
      var p0 = n[kapali ? (i - 1 + m) % m : Math.max(0, i - 1)], p1 = n[i], p2 = n[(i + 1) % m];
      var p3 = n[kapali ? (i + 2) % m : Math.min(m - 1, i + 2)];
      s += ' C' + f(p1[0] + (p2[0] - p0[0]) / 6) + ' ' + f(p1[1] + (p2[1] - p0[1]) / 6) + ' ' +
        f(p2[0] - (p3[0] - p1[0]) / 6) + ' ' + f(p2[1] - (p3[1] - p1[1]) / 6) + ' ' + f(p2[0]) + ' ' + f(p2[1]);
    }
    return s + (kapali ? 'Z' : '');
  }
  function kose(n, kapali) { // koseli (duz cizgi) yol
    return n.map(function (p, i) { return (i ? 'L' : 'M') + f(p[0]) + ' ' + f(p[1]); }).join(' ') + (kapali ? 'Z' : '');
  }

  function kutu(n) {
    var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
    n.forEach(function (p) { x0 = Math.min(x0, p[0]); y0 = Math.min(y0, p[1]); x1 = Math.max(x1, p[0]); y1 = Math.max(y1, p[1]); });
    return { x0: x0, y0: y0, x1: x1, y1: y1, cx: (x0 + x1) / 2, cy: (y0 + y1) / 2, w: x1 - x0, h: y1 - y0 };
  }

  function elips(cx, cy, rx, ry, n, aci) {
    var out = [];
    for (var i = 0; i < n; i++) {
      var t = 2 * Math.PI * i / n;
      out.push([rx * Math.cos(t), ry * Math.sin(t)]);
    }
    return donustur(out, { aci: aci || 0, x: cx, y: cy });
  }

  function icindeMi(p, n) {
    var ic = false;
    for (var i = 0, j = n.length - 1; i < n.length; j = i++) {
      if (((n[i][1] > p[1]) !== (n[j][1] > p[1])) &&
          (p[0] < (n[j][0] - n[i][0]) * (p[1] - n[i][1]) / (n[j][1] - n[i][1]) + n[i][0])) ic = !ic;
    }
    return ic;
  }
  function kenaraUzaklik(p, n) {
    var en = 1e9;
    for (var i = 0, j = n.length - 1; i < n.length; j = i++) {
      var ax = n[j][0], ay = n[j][1], bx = n[i][0], by = n[i][1];
      var dx = bx - ax, dy = by - ay, l = dx * dx + dy * dy || 1;
      var t = Math.max(0, Math.min(1, ((p[0] - ax) * dx + (p[1] - ay) * dy) / l));
      en = Math.min(en, Math.hypot(p[0] - ax - t * dx, p[1] - ay - t * dy));
    }
    return en;
  }

  // ---------- boyama ----------

  /*
    Cizgi film golgesi: ayni siluet isiga dogru kaydirilarak ust uste boyanir.
    Altta yansima rengi, ustunde az kaymis golge, daha cok kaymis ana renk, en ustte kucultulmus isik.
    Sonuc: sag altta ince yansima seridi + golge hilali, sol ustte isik alani.
    r: { rim, golge, ana, acik }, o: { r, d, a, as (isik olcegi), ek (klip icine ek cizim), ic }
  */
  function cel(n, r, o) {
    o = o || {};
    var y = o.koseli ? kose(n, true) : yol(n, true), k = kutu(n), id = yeniId('k');
    ekDefs += '<clipPath id="' + id + '"><path d="' + y + '"/></clipPath>';
    var s = Math.max(k.w, k.h);
    var rr = o.r != null ? o.r : s * 0.025, d = o.d != null ? o.d : s * 0.09, a = o.a != null ? o.a : s * 0.15;
    var out = '<path d="' + y + '" fill="' + r.rim + '"/>' +
      '<g clip-path="url(#' + id + ')">' +
      '<path d="' + y + '" fill="' + r.golge + '" transform="translate(' + f(ISIK[0] * rr) + ' ' + f(ISIK[1] * rr) + ')"/>' +
      '<path d="' + y + '" fill="' + r.ana + '" transform="translate(' + f(ISIK[0] * d) + ' ' + f(ISIK[1] * d) + ')"/>';
    if (r.acik) {
      if (o.as) {
        out += '<path d="' + y + '" fill="' + r.acik + '" transform="translate(' + f(k.cx + ISIK[0] * a) + ' ' + f(k.cy + ISIK[1] * a) +
          ') scale(' + o.as + ') translate(' + f(-k.cx) + ' ' + f(-k.cy) + ')"/>';
      } else {
        out += '<path d="' + y + '" fill="' + r.acik + '" transform="translate(' + f(ISIK[0] * a) + ' ' + f(ISIK[1] * a) + ')"/>';
      }
    }
    out += (o.ek || '') + '</g>';
    if (o.ic !== 0) out += '<path d="' + y + '" fill="none" stroke="' + IC + '" stroke-width="' + (o.ic || 1.5) + '" stroke-linejoin="round"/>';
    return { svg: out, siluet: y, kutu: k, klip: id };
  }

  function parlama(x, y, rx, ry, aci, guc) {
    return '<ellipse cx="' + f(x) + '" cy="' + f(y) + '" rx="' + f(rx) + '" ry="' + f(ry) + '" transform="rotate(' + (aci || 0) + ' ' + f(x) + ' ' + f(y) + ')" fill="#FFFFFF" opacity="' + (guc || 0.9) + '"/>';
  }
  function yumusakParlama(x, y, rx, ry, aci, guc) {
    return '<ellipse cx="' + f(x) + '" cy="' + f(y) + '" rx="' + f(rx) + '" ry="' + f(ry) + '" transform="rotate(' + (aci || 0) + ' ' + f(x) + ' ' + f(y) + ')" fill="#FFFBEA" opacity="' + (guc || 0.35) + '" filter="url(#rmBul3)"/>';
  }

  // ---------- yaprak ----------

  var YAPRAK_TON = {
    arka: { dip: '#1E5530', orta: '#2E7A43', uc: '#4F9A58', golge: '#123D22', damar: '#63AE66', parlak: '#7FC27A' },
    orta: { dip: '#2A6E3A', orta: '#3F9A4F', uc: '#62B866', golge: '#1D5A2E', damar: '#8BD07E', parlak: '#A3DC92' },
    on: { dip: '#37843F', orta: '#58B560', uc: '#86D07C', golge: '#2A7336', damar: '#B2E8A2', parlak: '#CFF3BD' }
  };

  /*
    Tabani (x0,y0) olan, 'aci' ile egilmis (0 = yukari, + saat yonu), ucu 'kivrim' kadar kivrilan yaprak.
    profil: 'mizrak' (dipte genis, ananas/cilek canagi) | 'orta' (ortada genis, mango/seftali yapragi)
  */
  function yaprakGeo(x0, y0, aci, uzun, gen, kivrim, profil) {
    var a = aci * Math.PI / 180, ca = Math.cos(a), sa = Math.sin(a);
    function don(x, y) { return [x0 + x * ca - y * sa, y0 + x * sa + y * ca]; }
    function omurga(s) {
      var P0 = [0, uzun * 0.08], P1 = [0, -uzun * 0.6], P2 = [kivrim, -uzun], u = 1 - s;
      return {
        x: u * u * P0[0] + 2 * u * s * P1[0] + s * s * P2[0],
        y: u * u * P0[1] + 2 * u * s * P1[1] + s * s * P2[1],
        tx: 2 * u * (P1[0] - P0[0]) + 2 * s * (P2[0] - P1[0]),
        ty: 2 * u * (P1[1] - P0[1]) + 2 * s * (P2[1] - P1[1])
      };
    }
    function yariGen(s) {
      if (profil === 'orta') return (gen / 2) * Math.pow(Math.sin(Math.PI * Math.min(1, 0.06 + s * 0.94)), 0.85);
      return (gen / 2) * Math.min(1, 0.2 + s * 5) * Math.pow(1 - s, 0.9);
    }
    var solK = [], sagK = [], orta = [], parlak = [];
    for (var i = 0; i <= 24; i++) {
      var s = i / 24, p = omurga(s), l = Math.hypot(p.tx, p.ty) || 1;
      var nx = -p.ty / l, ny = p.tx / l, w = yariGen(s);
      solK.push(don(p.x - nx * w, p.y - ny * w));
      sagK.push(don(p.x + nx * w, p.y + ny * w));
      orta.push(don(p.x, p.y));
      parlak.push(don(p.x - nx * w * 0.62, p.y - ny * w * 0.62));
    }
    var dis = solK.concat(sagK.slice().reverse());
    return {
      dis: kose(dis, true),
      golge: kose(orta.concat(sagK.slice().reverse()), true),
      damar: kose(orta.slice(3, 20)),
      parlak: kose(parlak.slice(5, 18)),
      dip: don(0, uzun * 0.08), uc: don(kivrim, -uzun)
    };
  }

  function yaprak(x0, y0, aci, uzun, gen, kivrim, ton, profil) {
    var g = yaprakGeo(x0, y0, aci, uzun, gen, kivrim, profil);
    var t = YAPRAK_TON[ton] || ton, id = yeniId('y');
    ekDefs += '<linearGradient id="' + id + '" gradientUnits="userSpaceOnUse" x1="' + f(g.dip[0]) + '" y1="' + f(g.dip[1]) + '" x2="' + f(g.uc[0]) + '" y2="' + f(g.uc[1]) + '">' +
      '<stop offset="0" stop-color="' + t.dip + '"/><stop offset=".45" stop-color="' + t.orta + '"/><stop offset="1" stop-color="' + t.uc + '"/></linearGradient>';
    var damarlar = '';
    if (profil === 'orta') {
      // genis yaprakta yan damarlar
      var o = yaprakGeo(x0, y0, aci, uzun, gen * 0.62, kivrim, profil);
      damarlar = '<path d="' + o.dis + '" fill="none" stroke="' + t.damar + '" stroke-width=".7" stroke-dasharray="1.5 5" opacity=".7"/>';
    }
    return {
      siluet: g.dis, kalin: 3.6,
      svg: '<path d="' + g.dis + '" fill="url(#' + id + ')"/>' +
        '<path d="' + g.golge + '" fill="' + t.golge + '" opacity=".42"/>' +
        damarlar +
        '<path d="' + g.parlak + '" fill="none" stroke="' + t.parlak + '" stroke-width="1.1" stroke-linecap="round" opacity=".85"/>' +
        '<path d="' + g.damar + '" fill="none" stroke="' + t.damar + '" stroke-width="1.3" stroke-linecap="round" opacity=".9"/>' +
        '<path d="' + g.dis + '" fill="none" stroke="' + IC + '" stroke-width="1.5" stroke-linejoin="round"/>'
    };
  }

  // ---------- sap ----------

  var SAP_TON = { rim: '#8E6A3E', golge: '#553718', ana: '#79532D', acik: '#9C7446' };

  // p0 (dip) -> p2 (uc) ikinci derece egri boyunca kalinligi w olan sap; ucunda kesik yuzey
  function sap(p0, p1, p2, w, ton, ucRenk) {
    ton = ton || SAP_TON;
    var sol = [], sag = [];
    for (var i = 0; i <= 12; i++) {
      var s = i / 12, u = 1 - s;
      var x = u * u * p0[0] + 2 * u * s * p1[0] + s * s * p2[0], y = u * u * p0[1] + 2 * u * s * p1[1] + s * s * p2[1];
      var tx = 2 * u * (p1[0] - p0[0]) + 2 * s * (p2[0] - p1[0]), ty = 2 * u * (p1[1] - p0[1]) + 2 * s * (p2[1] - p1[1]);
      var l = Math.hypot(tx, ty) || 1, nx = -ty / l, ny = tx / l, ww = w / 2 * (1.12 - 0.12 * s);
      sol.push([x - nx * ww, y - ny * ww]); sag.push([x + nx * ww, y + ny * ww]);
    }
    var n = sol.concat(sag.slice().reverse());
    var c = cel(n, ton, { r: 0.6, d: w * 0.32, a: w * 0.62, ic: 1.2 });
    var tl = Math.hypot(p2[0] - p1[0], p2[1] - p1[1]) || 1;
    var aci = Math.atan2(p2[1] - p1[1], p2[0] - p1[0]) * 180 / Math.PI + 90;
    var uc = '<ellipse cx="' + f(p2[0]) + '" cy="' + f(p2[1]) + '" rx="' + f(w / 2) + '" ry="' + f(w / 4.2) + '" transform="rotate(' + f(aci) + ' ' + f(p2[0]) + ' ' + f(p2[1]) + ')" fill="' + (ucRenk || '#B89A6A') + '" stroke="' + IC + '" stroke-width="1.1"/>';
    return { siluet: c.siluet, kalin: 3.4, svg: c.svg + uc };
  }

  function dugum(x, y, r, renk) {
    return { siluet: null, svg: '<circle cx="' + f(x) + '" cy="' + f(y) + '" r="' + f(r) + '" fill="' + (renk || '#6E4A26') + '" stroke="' + IC + '" stroke-width="1.2"/>' +
      '<circle cx="' + f(x - r * 0.3) + '" cy="' + f(y - r * 0.35) + '" r="' + f(r * 0.35) + '" fill="#A8845A"/>' };
  }

  // ---------- birlestirme ----------

  // Parcalari ciz: once yer golgesi, sonra kalin dis kontur (iki kez, sag alta kaydirarak), en son parcalar sirayla.
  function birlestir(parcalar, zemin) {
    var s = '';
    if (zemin) {
      s += '<ellipse cx="' + f(zemin.x) + '" cy="' + f(zemin.y) + '" rx="' + f(zemin.rx) + '" ry="' + f(zemin.ry || 5.5) + '" fill="' + K + '" opacity=".2" filter="url(#rmBul1)"/>';
    }
    [[0, 0], [0.9, 1.1]].forEach(function (o) {
      parcalar.forEach(function (p) {
        if (p.siluet) s += '<path transform="translate(' + o[0] + ' ' + o[1] + ')" d="' + p.siluet + '" fill="' + K + '" stroke="' + K + '" stroke-width="' + (p.kalin || 4.4) + '" stroke-linejoin="round"/>';
      });
    });
    parcalar.forEach(function (p) { s += p.svg; });
    return s;
  }

  // ======================================================================
  //                                MEYVELER
  // ======================================================================

  // ---------- ananas ----------
  function ananas() {
    var CX = 100, CY = 141, RX = 41, RY = 50, ALFA = 0.24, P = 2.5;
    var L = (function () { var v = [-0.55, -0.6, 0.58], l = Math.hypot(v[0], v[1], v[2]); return v.map(function (x) { return x / l; }); })();

    function yaricap(t) { return Math.pow(1 - Math.pow(Math.abs(t), P), 1 / P); }
    function egim(t) {
      var a = Math.abs(t); if (a < 1e-4) return 0;
      return -Math.sign(t) * Math.pow(a, P - 1) * Math.pow(Math.max(1e-6, 1 - Math.pow(a, P)), 1 / P - 1);
    }
    function nokta(teta, t) {
      t = Math.max(-0.999, Math.min(0.999, t));
      var c = yaricap(t), X = Math.sin(teta) * c, Y = t, Z = Math.cos(teta) * c;
      var Y2 = Y * Math.cos(ALFA) + Z * Math.sin(ALFA), Z2 = Z * Math.cos(ALFA) - Y * Math.sin(ALFA);
      var e = egim(t), nx = Math.sin(teta), ny = -e, nz = Math.cos(teta), nl = Math.hypot(nx, ny, nz);
      nx /= nl; ny /= nl; nz /= nl;
      var ny2 = ny * Math.cos(ALFA) + nz * Math.sin(ALFA), nz2 = nz * Math.cos(ALFA) - ny * Math.sin(ALFA);
      return { x: CX + RX * X, y: CY + RY * Y2, z: Z2, isik: nx * L[0] + ny2 * L[1] + nz2 * L[2], yan: nx };
    }
    function siluet() {
      var pts = [];
      for (var i = 0; i < 96; i++) for (var j = 0; j <= 80; j++) {
        var q = nokta(i / 96 * 2 * Math.PI, -1 + j / 40);
        pts.push([q.x, q.y]);
      }
      pts.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
      function cross(o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); }
      var alt = [], ust = [];
      pts.forEach(function (p) { while (alt.length >= 2 && cross(alt[alt.length - 2], alt[alt.length - 1], p) <= 0) alt.pop(); alt.push(p); });
      for (var k = pts.length - 1; k >= 0; k--) { var p = pts[k]; while (ust.length >= 2 && cross(ust[ust.length - 2], ust[ust.length - 1], p) <= 0) ust.pop(); ust.push(p); }
      return kose(alt.slice(0, -1).concat(ust.slice(0, -1)), true);
    }
    var TEPE = nokta(0, -1);

    var BANT = [
      { r: ['#FFF3B0', '#FFD95F', '#F2AE3A'], cizgi: '#FFF6CC' },
      { r: ['#FFE08A', '#F7B23A', '#E0902C'], cizgi: '#FFE9A6' },
      { r: ['#F7B44C', '#E28B2B', '#C56E1F'], cizgi: '#F8C066' },
      { r: ['#DB8A33', '#BD6922', '#9E5118'], cizgi: null }
    ];
    BANT.forEach(function (b) {
      b.id = yeniId('p');
      ekDefs += '<linearGradient id="' + b.id + '" x1=".15" y1=".05" x2=".85" y2=".95"><stop offset="0" stop-color="' + b.r[0] + '"/><stop offset=".5" stop-color="' + b.r[1] + '"/><stop offset="1" stop-color="' + b.r[2] + '"/></linearGradient>';
    });
    function bant(d) { return d > 0.6 ? BANT[0] : d > 0.26 ? BANT[1] : d > -0.05 ? BANT[2] : BANT[3]; }

    function pullar() {
      var N = 14, dTeta = 2 * Math.PI / N, dt = 0.165, liste = [];
      for (var j = 0; j * dt <= 2.1; j++) {
        var t = -1.02 + j * dt;
        for (var i = -N / 2; i <= N / 2; i++) {
          var teta = (i + (j % 2) * 0.5) * dTeta, m = nokta(teta, t);
          if (m.z < -0.08) continue;
          liste.push({ teta: teta, t: t, z: m.z });
        }
      }
      liste.sort(function (a, b) { return a.z - b.z; });
      var s = '';
      liste.forEach(function (p) {
        var o = nokta(p.teta, p.t);
        var ust = nokta(p.teta, p.t - dt), alt = nokta(p.teta, p.t + dt);
        var sol = nokta(p.teta - dTeta / 2, p.t), sag = nokta(p.teta + dTeta / 2, p.t);
        function ic(q) { return { x: o.x + (q.x - o.x) * 0.86, y: o.y + (q.y - o.y) * 0.86 }; }
        ust = ic(ust); alt = ic(alt); sol = ic(sol); sag = ic(sag);
        function kab(a, b, g) { var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2; g = g || 1.3; return f(o.x + (mx - o.x) * g) + ' ' + f(o.y + (my - o.y) * g); }
        var genis = Math.hypot(sag.x - sol.x, sag.y - sol.y);
        if (genis < 2.2) return;
        var b = bant(o.isik);
        if (b === BANT[3] && o.yan > 0.8 && p.t > -0.6 && p.t < 0.75) b = BANT[2];
        var kalin = Math.max(0.5, Math.min(1.15, genis * 0.065));
        var d = 'M' + f(ust.x) + ' ' + f(ust.y) + ' Q' + kab(ust, sag) + ' ' + f(sag.x) + ' ' + f(sag.y) + ' Q' + kab(sag, alt) + ' ' + f(alt.x) + ' ' + f(alt.y) +
          ' Q' + kab(alt, sol) + ' ' + f(sol.x) + ' ' + f(sol.y) + ' Q' + kab(sol, ust) + ' ' + f(ust.x) + ' ' + f(ust.y) + 'Z';
        s += '<path d="' + d + '" fill="url(#' + b.id + ')" stroke="#8E4A15" stroke-width="' + f(kalin) + '" stroke-linejoin="round"/>';
        var h = Math.sin(p.teta * 91.7 + p.t * 57.3) * 43758.5453; h -= Math.floor(h);
        var yesil = Math.max(0, Math.min(0.32, (-0.5 - p.t) * 0.7)) + h * 0.07;
        if (yesil > 0.02) s += '<path d="' + d + '" fill="#8FA82A" opacity="' + yesil.toFixed(2) + '"/>';
        if (h > 0.8) s += '<path d="' + d + '" fill="#E0701C" opacity=".14"/>';
        if (b.cizgi) {
          s += '<path d="M' + f(sol.x + (o.x - sol.x) * 0.28) + ' ' + f(sol.y + (o.y - sol.y) * 0.28) + ' Q' + kab(sol, ust, 1.12) + ' ' +
            f(ust.x + (o.x - ust.x) * 0.28) + ' ' + f(ust.y + (o.y - ust.y) * 0.28) + '" fill="none" stroke="' + b.cizgi + '" stroke-width="' + f(kalin * 1.25) + '" stroke-linecap="round" opacity=".9"/>';
        }
        var uc = { x: o.x + (ust.x - o.x) * 0.6, y: o.y + (ust.y - o.y) * 0.6 };
        var dip = { x: o.x + (ust.x - o.x) * 0.02, y: o.y + (ust.y - o.y) * 0.02 };
        var gx = (sag.x - sol.x) * 0.1, gy = (sag.y - sol.y) * 0.1;
        s += '<path d="M' + f(uc.x) + ' ' + f(uc.y) + ' Q' + f(dip.x - gx * 1.2) + ' ' + f(dip.y - gy * 1.2 - 0.3) + ' ' + f(dip.x) + ' ' + f(dip.y + 0.6) +
          ' Q' + f(dip.x + gx * 1.2) + ' ' + f(dip.y + gy * 1.2 - 0.3) + ' ' + f(uc.x) + ' ' + f(uc.y) + 'Z" fill="#6A330F"/>';
      });
      return s;
    }

    var govdeYolu = siluet(), klip = yeniId('k');
    ekDefs += '<clipPath id="' + klip + '"><path d="' + govdeYolu + '"/></clipPath>';

    var arka = [], on = [];
    function y(aci, uzun, gen, kiv, ton, dx, dy, dizi) {
      var r = aci * Math.PI / 180;
      dizi.push(yaprak(TEPE.x + Math.sin(r) * 4 + (dx || 0), TEPE.y + 1 + (dy || 0), aci, uzun * 0.86, gen * 0.95, kiv * 0.9, ton));
    }
    y(-52, 58, 15, -16, 'arka', 0, -1, arka); y(54, 56, 15, 17, 'arka', 0, -1, arka);
    y(-26, 72, 16, -8, 'arka', 0, -2, arka); y(28, 70, 16, 9, 'arka', 0, -2, arka);
    y(3, 80, 16, 3, 'arka', 0, -2, arka);
    y(-70, 46, 14, -17, 'orta', 0, 1, arka); y(71, 44, 14, 17, 'orta', 0, 1, arka);
    y(-40, 58, 15, -10, 'orta', 0, 0, arka); y(42, 56, 15, 11, 'orta', 0, 0, arka);
    y(-13, 66, 15, -4, 'orta', 0, 0, arka); y(15, 64, 15, 5, 'orta', 0, 0, arka);
    y(-64, 30, 13, -9, 'on', -1, 3, on); y(65, 29, 13, 9, 'on', 1, 3, on);
    y(-35, 36, 14, -5, 'on', 0, 3, on); y(36, 35, 14, 5, 'on', 0, 3, on);
    y(-3, 40, 14, 0, 'on', 0, 3, on);
    y(-86, 20, 11, -6, 'on', -3, 5, on); y(86, 20, 11, 6, 'on', 3, 5, on);

    var govde = {
      siluet: govdeYolu, kalin: 4.6,
      svg: '<path d="' + govdeYolu + '" fill="#A0561A"/>' +
        '<g clip-path="url(#' + klip + ')">' + pullar() +
        '<ellipse cx="' + f(TEPE.x + 5) + '" cy="' + f(TEPE.y + 9) + '" rx="30" ry="12" fill="#5A2508" opacity=".38" filter="url(#rmBul4)"/>' +
        '<ellipse cx="' + (CX + 12) + '" cy="' + (CY + RY + 8) + '" rx="' + RX + '" ry="22" fill="#6B2E0B" opacity=".25" filter="url(#rmBul4)"/>' +
        yumusakParlama(CX - 22, CY - 18, 8, 15, 18, 0.2) + parlama(CX - 25, CY - 27, 2.6, 4, 18) +
        '</g>' +
        '<path d="' + govdeYolu + '" fill="none" stroke="' + IC + '" stroke-width="1.6"/>'
    };
    return birlestir(arka.concat([govde], on), { x: CX + 3, y: CY + RY + 2, rx: RX * 0.86 });
  }

  // ---------- mango ----------
  function mango() {
    var yerel = kubik([[4, -74], [36, -76], [58, -44], [57, -8], [56, 30], [38, 66], [6, 74], [-14, 79], [-30, 70], [-38, 60],
      [-44, 52], [-42, 44], [-47, 36], [-58, 16], [-58, -22], [-46, -46], [-34, -68], [-16, -74], [4, -74]], 10);
    yerel.pop();
    var T = { aci: -38, olcek: 0.86, x: 102, y: 118 };
    var n = donustur(yerel, T), up = yon(T);
    function yer(x, y) { return donustur([[x, y]], T)[0]; }
    var R = rastgele(7), benek = '';
    for (var i = 0; i < 60; i++) {
      var p = yer(-50 + R() * 100, -66 + R() * 136);
      if (icindeMi(p, n) && kenaraUzaklik(p, n) > 4) {
        benek += '<circle cx="' + f(p[0]) + '" cy="' + f(p[1]) + '" r="' + f(0.6 + R() * 0.7) + '" fill="#FFF0B8" opacity="' + f(0.45 + R() * 0.35) + '"/>';
      }
    }
    var sapDip = yer(4, -71);
    var yesil = yer(-4, -50), kirmizi = yer(30, -18), dimple = yer(4, -70), parla1 = yer(-28, -20), parla2 = yer(-32, -36);
    var govde = cel(n, { rim: '#F7A23C', golge: '#DB6E22', ana: '#FFAE2E', acik: '#FFD25A' }, {
      as: 0.58,
      ek: '<ellipse cx="' + f(yesil[0]) + '" cy="' + f(yesil[1]) + '" rx="32" ry="24" transform="rotate(-38 ' + f(yesil[0]) + ' ' + f(yesil[1]) + ')" fill="#9DB83A" opacity=".62" filter="url(#rmBul6)"/>' +
        '<ellipse cx="' + f(kirmizi[0]) + '" cy="' + f(kirmizi[1]) + '" rx="40" ry="30" transform="rotate(-38 ' + f(kirmizi[0]) + ' ' + f(kirmizi[1]) + ')" fill="#E6403A" opacity=".72" filter="url(#rmBul8)"/>' +
        benek +
        '<ellipse cx="' + f(dimple[0]) + '" cy="' + f(dimple[1]) + '" rx="7" ry="3" transform="rotate(-38 ' + f(dimple[0]) + ' ' + f(dimple[1]) + ')" fill="#8A5A1C" opacity=".6"/>' +
        yumusakParlama(parla1[0], parla1[1], 9, 16, -38, 0.3) + parlama(parla2[0], parla2[1], 3, 6.5, -38)
    });
    govde.kalin = 4.6;
    var sapUc = [sapDip[0] + up[0] * 17 + 2, sapDip[1] + up[1] * 17];
    var s = sap(sapDip, [sapDip[0] + up[0] * 9 + 3, sapDip[1] + up[1] * 9], sapUc, 6.5);
    var y = yaprak(sapUc[0], sapUc[1], 62, 54, 21, 12, 'orta', 'orta');
    var d = dugum(sapUc[0], sapUc[1], 3.8);
    var k = govde.kutu;
    return birlestir([govde, s, y, d], { x: k.cx + 4, y: k.y1 + 2, rx: k.w * 0.4 });
  }

  // ---------- muz ----------
  function muz() {
    var P0 = [-68, -16], P1 = [-4, 48], P2 = [62, -28];
    var t2 = [P2[0] - P1[0], P2[1] - P1[1]], tl = Math.hypot(t2[0], t2[1]);
    t2 = [t2[0] / tl, t2[1] / tl];
    var TAC_YEREL = [P2[0] + t2[0] * 15, P2[1] + t2[1] * 15];
    var TAC = [161, 72];

    function tekMuz(aci, ton, benekli) {
      var T = { aci: aci, olcek: 0.98, x: TAC[0], y: TAC[1], ox: TAC_YEREL[0], oy: TAC_YEREL[1] };
      var sol = [], sag = [], ust = [], alt = [];
      for (var i = 0; i <= 40; i++) {
        var s = i / 40, u = 1 - s;
        var x = u * u * P0[0] + 2 * u * s * P1[0] + s * s * P2[0], y = u * u * P0[1] + 2 * u * s * P1[1] + s * s * P2[1];
        var tx = 2 * u * (P1[0] - P0[0]) + 2 * s * (P2[0] - P1[0]), ty = 2 * u * (P1[1] - P0[1]) + 2 * s * (P2[1] - P1[1]);
        var l = Math.hypot(tx, ty), nx = -ty / l, ny = tx / l;
        var w = 16 * Math.pow(Math.sin(Math.PI * (0.05 + 0.9 * s)), 0.72);
        if (s > 0.9) w = Math.max(w, 5.2);
        sol.push([x - nx * w, y - ny * w]); sag.push([x + nx * w, y + ny * w]);
        if (s > 0.1 && s < 0.9) { ust.push([x - nx * w * 0.4, y - ny * w * 0.4]); alt.push([x + nx * w * 0.5, y + ny * w * 0.5]); }
      }
      var govdeN = donustur(sol.concat(sag.slice().reverse()), T);
      var ustN = donustur(ust, T), altN = donustur(alt, T);
      var ek = '<path d="' + yol(ustN) + '" fill="none" stroke="#FFF4B4" stroke-width="1.4" stroke-linecap="round" opacity=".9"/>' +
        '<path d="' + yol(altN) + '" fill="none" stroke="' + ton.sirt + '" stroke-width="1.2" stroke-linecap="round" opacity=".85"/>';
      if (benekli) {
        [[-30, 20], [-12, 26], [8, 22], [24, 12], [-40, 12]].forEach(function (p, i) {
          var q = donustur([p], T)[0];
          ek += '<ellipse cx="' + f(q[0]) + '" cy="' + f(q[1]) + '" rx="' + (1.4 - i * 0.12).toFixed(2) + '" ry="1" fill="#8A5A24" opacity=".55"/>';
        });
      }
      var parlaP = donustur([[-20, 8]], T)[0];
      ek += parlama(parlaP[0], parlaP[1], 6, 1.8, aci - 18, 0.8);
      var govde = cel(govdeN, ton, { r: 1.1, d: 6.5, a: 17, ek: ek });
      govde.kalin = 4.4;
      // koyu uc
      var ucN = donustur(elips(P0[0] + 1, P0[1] + 1, 4.2, 3.4, 16, 0), T);
      var uc = { siluet: null, svg: '<path d="' + yol(ucN, true) + '" fill="#5A3A1A" stroke="' + IC + '" stroke-width="1.2"/>' };
      // boyun (sap tarafi)
      var boyun = [];
      for (var j = 0; j <= 6; j++) {
        var bs = j / 6, bx = P2[0] + t2[0] * 16 * bs, by = P2[1] + t2[1] * 16 * bs, bw = 5.4 + bs * 0.8;
        boyun.push([[bx + t2[1] * bw, by - t2[0] * bw], [bx - t2[1] * bw, by + t2[0] * bw]]);
      }
      var boyunN = donustur(boyun.map(function (b) { return b[0]; }).concat(boyun.map(function (b) { return b[1]; }).reverse()), T);
      var b = cel(boyunN, { rim: '#A5A33E', golge: '#6E7424', ana: '#A9B141', acik: '#CBD06E' }, { r: 0.6, d: 2.4, a: 5, ic: 1.2 });
      b.kalin = 3.6;
      return [govde, uc, b];
    }

    var TONLAR = [
      { rim: '#E9B42A', golge: '#C68A16', ana: '#F3C230', acik: '#FFDF74', sirt: '#C98E1A' },
      { rim: '#F2C230', golge: '#D6981A', ana: '#FFD03A', acik: '#FFE985', sirt: '#D39A1D' },
      { rim: '#F6CB3A', golge: '#DCA21E', ana: '#FFD944', acik: '#FFF095', sirt: '#D8A220' }
    ];
    var parcalar = [].concat(tekMuz(10, TONLAR[0]), tekMuz(-10, TONLAR[1]), tekMuz(-31, TONLAR[2], true));
    // salkim sapi: uc muzun boyunlarini birlestirir
    var sapUc = [TAC[0] + 11, TAC[1] - 12];
    parcalar.push(sap([TAC[0] - 3, TAC[1] + 3], [TAC[0] + 4, TAC[1] - 4], sapUc, 11,
      { rim: '#8C8A36', golge: '#565A1E', ana: '#7C8030', acik: '#A2A64C' }, '#D8D08E'));
    return birlestir(parcalar, { x: 104, y: 184, rx: 62 });
  }

  // ---------- karpuz ----------
  function karpuz() {
    var C = [98, 98], R = 76, ACI = -14;
    function dilim(r, dx, dy) {
      var n = [];
      for (var i = 0; i <= 10; i++) n.push([-r + 2 * r * i / 10, 0]);
      for (var j = 1; j < 40; j++) { var t = Math.PI * j / 40; n.push([r * Math.cos(t), r * Math.sin(t)]); }
      return donustur(n, { aci: ACI, x: C[0] + (dx || 0), y: C[1] + (dy || 0) });
    }
    function yer(x, y) { return donustur([[x, y]], { aci: ACI, x: C[0], y: C[1] })[0]; }

    // Arka yuz: dilimin kalinligi (ust serit ve sag kenar gorunur)
    var arka = cel(dilim(R, 7, -8), { rim: '#2A7A3E', golge: '#1C5A2C', ana: '#246C36', acik: null }, { r: 1, d: 3, ic: 1.2 });
    var arkaKabuk = '<path d="' + yol(dilim(R * 0.905, 7, -8), true) + '" fill="#D5ECA2"/>';
    var arkaEt = '<path d="' + yol(dilim(R * 0.845, 7, -8), true) + '" fill="#FF7565"/>';
    var arkaParca = { siluet: arka.siluet, kalin: 4.6, svg: arka.svg + arkaKabuk + arkaEt };

    // Kabuk seritleri
    var serit = '';
    for (var k = 0; k < 9; k++) {
      var a1 = (10 + k * 19) * Math.PI / 180, a2 = a1 + 7 * Math.PI / 180;
      var kama = donustur([[0, 0], [R * 1.3 * Math.cos(a1), R * 1.3 * Math.sin(a1)], [R * 1.3 * Math.cos((a1 + a2) / 2) + 3, R * 1.3 * Math.sin((a1 + a2) / 2)], [R * 1.3 * Math.cos(a2), R * 1.3 * Math.sin(a2)]], { aci: ACI, x: C[0], y: C[1] });
      serit += '<path d="' + kose(kama, true) + '" fill="#1B5A2C" opacity=".9"/>';
    }
    var dis = cel(dilim(R), { rim: '#3A9A50', golge: '#1F6B34', ana: '#2E8B45', acik: '#45A85A' }, { r: 1.2, d: 3.5, a: 7, ek: serit });
    dis.kalin = 4.6;
    var kabuk = cel(dilim(R * 0.905), { rim: '#CFE69C', golge: '#B9D784', ana: '#E4F3B8', acik: '#F4FBD8' }, { r: 0.8, d: 2.5, a: 5, ic: 0.9 });

    // Et: cekirdekler + sulu cizgiler
    var ek = '';
    var R2 = rastgele(3);
    for (var s = 0; s < 14; s++) {
      var ra = R * (0.2 + R2() * 0.6), aa = Math.PI * (0.12 + R2() * 0.76);
      var p1 = yer(ra * Math.cos(aa), ra * Math.sin(aa)), p2 = yer((ra + 6) * Math.cos(aa), (ra + 6) * Math.sin(aa));
      ek += '<path d="M' + f(p1[0]) + ' ' + f(p1[1]) + ' L' + f(p2[0]) + ' ' + f(p2[1]) + '" stroke="#FF8F80" stroke-width="1.2" stroke-linecap="round" opacity=".7"/>';
    }
    [[0.36, 52], [0.36, 90], [0.36, 128], [0.62, 26], [0.62, 55], [0.62, 83], [0.62, 111], [0.62, 139], [0.64, 160]].forEach(function (c) {
      var a = c[1] * Math.PI / 180, r = R * c[0];
      var merkez = [r * Math.cos(a), r * Math.sin(a)];
      // ucu dilimin merkezine bakan damla
      var yon1 = [-Math.cos(a), -Math.sin(a)], dik = [-yon1[1], yon1[0]];
      var damla = [];
      for (var i = 0; i < 16; i++) {
        var t = 2 * Math.PI * i / 16, rr = 2.7 * (1 - 0.55 * Math.pow(Math.max(0, Math.cos(t)), 3));
        var ux = Math.cos(t) * (Math.cos(t) > 0 ? 4.8 : 2.8), uy = Math.sin(t) * rr;
        damla.push([merkez[0] + yon1[0] * ux + dik[0] * uy, merkez[1] + yon1[1] * ux + dik[1] * uy]);
      }
      var dN = donustur(damla, { aci: ACI, x: C[0], y: C[1] });
      var hp = yer(merkez[0] - yon1[0] * 0.5 - dik[0] * 1, merkez[1] - yon1[1] * 0.5 - dik[1] * 1);
      ek += '<path d="' + yol(dN, true) + '" fill="#2A1812"/>' + '<circle cx="' + f(hp[0]) + '" cy="' + f(hp[1]) + '" r=".9" fill="#FFFFFF" opacity=".8"/>';
    });
    var kenarA = yer(-R * 0.8, 2.2), kenarB = yer(R * 0.8, 2.2);
    ek += '<path d="M' + f(kenarA[0]) + ' ' + f(kenarA[1]) + ' L' + f(kenarB[0]) + ' ' + f(kenarB[1]) + '" stroke="#FF9A8A" stroke-width="1.6" stroke-linecap="round" opacity=".8"/>';
    var pr = yer(-R * 0.45, R * 0.2);
    ek += parlama(pr[0], pr[1], 5, 2.2, ACI - 25, 0.75);
    var et = cel(dilim(R * 0.845), { rim: '#E63C40', golge: '#C92A37', ana: '#F2463F', acik: '#FF6E5E' }, { as: 0.6, a: 16, ek: ek, ic: 1 });

    var k = kutu(dilim(R));
    return birlestir([arkaParca, dis, { siluet: null, svg: kabuk.svg }, { siluet: null, svg: et.svg }], { x: k.cx + 5, y: k.y1 + 4, rx: R * 0.62 });
  }

  // ---------- uzum ----------
  function uzum() {
    var parcalar = [];
    // asma yapragi: bes loblu, kenari hafif tirtikli; sapa bagli, uzumlerin arkasinda
    (function () {
      var x0 = 97, y0 = 52, aci = -56, L = 36, n = [];
      for (var d = -150; d <= 150; d += 2) {
        var fi = d * Math.PI / 180, w = (1 + Math.cos(5 * fi)) / 2;
        var r = L * (0.64 + 0.36 * Math.pow(w, 0.75)) + L * 0.035 * Math.abs(Math.sin(16 * fi));
        if (Math.abs(d) > 118) r *= 1 - (Math.abs(d) - 118) / 40;
        n.push([r * Math.sin(fi), -r * Math.cos(fi)]);
      }
      n.push([0, 0]);
      var N = donustur(n, { aci: aci, x: x0, y: y0 });
      var damar = '';
      [0, -72, 72, -135, 135].forEach(function (d) {
        var uz = Math.abs(d) > 100 ? 0.5 : 0.82;
        var p = donustur([[0, 0], [L * uz * Math.sin(d * Math.PI / 180), -L * uz * Math.cos(d * Math.PI / 180)]], { aci: aci, x: x0, y: y0 });
        damar += '<path d="' + kose(p) + '" stroke="#A6DE92" stroke-width="1.2" stroke-linecap="round" opacity=".85"/>';
      });
      var c = cel(N, { rim: '#3C8C48', golge: '#256A35', ana: '#4FA457', acik: '#72C06A' }, { as: 0.6, ek: damar });
      c.kalin = 3.6;
      parcalar.push(c);
    })();
    parcalar.push(sap([100, 80], [99, 62], [95, 44], 6));
    // kivrik filiz
    var fil = [];
    for (var i = 0; i <= 40; i++) {
      var t = i / 40 * 3.2 * Math.PI, r = 8 * (1 - t / (3.8 * Math.PI));
      fil.push([110 + r * Math.cos(t + Math.PI), 56 + r * Math.sin(t + Math.PI) * 0.9]);
    }
    fil.unshift([97, 60]);
    parcalar.push({ siluet: null, svg: '<path d="' + yol(fil) + '" fill="none" stroke="' + K + '" stroke-width="4.2" stroke-linecap="round"/>' +
      '<path d="' + yol(fil) + '" fill="none" stroke="#6FAE4A" stroke-width="1.9" stroke-linecap="round"/>' });

    var TON = [
      { rim: '#7C47BE', golge: '#4E2380', ana: '#7440B4', acik: '#9360D0' },
      { rim: '#8A55CF', golge: '#5A2A8F', ana: '#8248C4', acik: '#A474E0' }
    ];
    var OL = 0.86, R = 15.5;
    [
      [[68, 70], [101, 64], [134, 71]],
      [[52, 98], [85, 96], [118, 96], [151, 100]],
      [[68, 124], [101, 124], [134, 125]],
      [[84, 150], [117, 150]],
      [[100, 173]]
    ].forEach(function (sira, si) {
      sira.forEach(function (p0) {
        var p = [100 + (p0[0] - 100) * OL, 124 + (p0[1] - 118) * OL];
        var n = elips(p[0], p[1], R, R * 0.98, 28, 0);
        var c = cel(n, TON[si === 0 ? 0 : 1], {
          r: 0.8, d: 3.8, a: 6, as: 0.52,
          ek: '<ellipse cx="' + f(p[0] + 3.5) + '" cy="' + f(p[1] + 5) + '" rx="8" ry="5.5" fill="#B08AE8" opacity=".18" filter="url(#rmBul3)"/>' +
            parlama(p[0] - 5.8, p[1] - 6.2, 3, 2, -35, 0.9) + '<circle cx="' + f(p[0] - 1.3) + '" cy="' + f(p[1] - 9) + '" r="1" fill="#FFFFFF" opacity=".8"/>'
        });
        c.kalin = 4.2;
        parcalar.push(c);
      });
    });
    return birlestir(parcalar, { x: 104, y: 188, rx: 36 });
  }

  // ---------- kivi ----------
  function kivi() {
    var C = [96, 112], RX = 60, RY = 55, ACI = -12;
    var kabukN = elips(C[0] + 11, C[1] + 4, RX, RY, 48, ACI);
    var R = rastgele(11), tuy = '';
    for (var i = 0; i < 70; i++) {
      var a = R() * 2 * Math.PI, rr = 0.6 + R() * 0.4;
      var p = donustur([[Math.cos(a) * RX * rr, Math.sin(a) * RY * rr]], { aci: ACI, x: C[0] + 11, y: C[1] + 4 })[0];
      var q = [p[0] + Math.cos(a) * 2.6, p[1] + Math.sin(a) * 2.6];
      tuy += '<path d="M' + f(p[0]) + ' ' + f(p[1]) + ' L' + f(q[0]) + ' ' + f(q[1]) + '" stroke="#B88A58" stroke-width="1" stroke-linecap="round" opacity=".7"/>';
    }
    var kabuk = cel(kabukN, { rim: '#9A6A3C', golge: '#5E3A1C', ana: '#7E5129', acik: '#9A6D40' }, { as: 0.6, ek: tuy });
    kabuk.kalin = 4.6;

    function yer(x, y) { return donustur([[x, y]], { aci: ACI, x: C[0], y: C[1] })[0]; }
    var yuzN = elips(C[0], C[1], RX, RY, 48, ACI);
    var ek = '';
    // kabuk kenari
    ek += '<path d="' + yol(elips(C[0], C[1], RX * 0.955, RY * 0.95, 48, ACI), true) + '" fill="none" stroke="#6E4523" stroke-width="3"/>';
    // isinsal cizgiler
    for (var j = 0; j < 22; j++) {
      var t = 2 * Math.PI * j / 22 + 0.1;
      var p1 = yer(Math.cos(t) * RX * 0.34, Math.sin(t) * RY * 0.34), p2 = yer(Math.cos(t + 0.05) * RX * 0.86, Math.sin(t + 0.05) * RY * 0.86);
      ek += '<path d="M' + f(p1[0]) + ' ' + f(p1[1]) + ' L' + f(p2[0]) + ' ' + f(p2[1]) + '" stroke="#C3E888" stroke-width="1.4" stroke-linecap="round" opacity=".75"/>';
    }
    ek += '<path d="' + yol(elips(C[0], C[1], RX * 0.44, RY * 0.44, 36, ACI), true) + '" fill="#B9E07A" opacity=".55"/>';
    // cekirdek halkasi
    for (var s = 0; s < 20; s++) {
      var ta = 2 * Math.PI * s / 20, rr2 = 0.39 + (s % 2) * 0.05;
      var m = [Math.cos(ta) * RX * rr2, Math.sin(ta) * RY * rr2], u = [Math.cos(ta), Math.sin(ta)], dk = [-u[1], u[0]];
      var damla = [];
      for (var k = 0; k < 12; k++) {
        var tt = 2 * Math.PI * k / 12, ux = Math.cos(tt) * (Math.cos(tt) > 0 ? 4.2 : 2), uy = Math.sin(tt) * 1.9 * (1 - 0.5 * Math.pow(Math.max(0, Math.cos(tt)), 3));
        damla.push([m[0] + u[0] * ux + dk[0] * uy, m[1] + u[1] * ux + dk[1] * uy]);
      }
      ek += '<path d="' + yol(donustur(damla, { aci: ACI, x: C[0], y: C[1] }), true) + '" fill="#1E1410"/>';
    }
    // orta
    var orta = cel(elips(C[0], C[1], RX * 0.27, RY * 0.23, 28, ACI - 8), { rim: '#E4DFA8', golge: '#D9D39A', ana: '#F3EFC7', acik: '#FFFCE6' }, { as: 0.55, ic: 0 });
    ek += orta.svg;
    var pr = yer(-RX * 0.52, -RY * 0.5);
    ek += parlama(pr[0], pr[1], 7, 3, ACI - 35, 0.7) + '<circle cx="' + f(pr[0] + 8) + '" cy="' + f(pr[1] - 5) + '" r="1.5" fill="#FFFFFF" opacity=".8"/>';
    var yuz = cel(yuzN, { rim: '#6FAE35', golge: '#5A962A', ana: '#7FC23E', acik: '#9DD452' }, { as: 0.62, d: 7, ek: ek });
    yuz.kalin = 4.6;
    var k2 = kutu(kabukN);
    return birlestir([kabuk, yuz], { x: k2.cx + 2, y: k2.y1 + 3, rx: RX * 0.8 });
  }

  // ---------- cilek ----------
  function cilek() {
    var yerel = kubik([[0, -48], [26, -60], [64, -50], [62, -18], [60, 12], [36, 46], [6, 68], [2, 71], [-2, 71], [-6, 68],
      [-36, 46], [-60, 12], [-62, -18], [-64, -50], [-26, -60], [0, -48]], 10);
    yerel.pop();
    var T = { aci: 8, olcek: 0.97, x: 100, y: 119 };
    var n = donustur(yerel, T);
    var tepe = donustur([[0, -46]], T)[0];
    var ek = '';
    for (var r = -60; r <= 70; r += 13) {
      for (var c = -70; c <= 70; c += 15) {
        var x = c + ((Math.round(r / 13) % 2) ? 7.5 : 0);
        var p = donustur([[x, r]], T)[0];
        if (!icindeMi(p, n)) continue;
        var dk = kenaraUzaklik(p, n);
        if (dk < 5 || Math.hypot(p[0] - tepe[0], p[1] - tepe[1]) < 24) continue;
        var o = Math.min(1, 0.35 + dk / 22);
        ek += '<ellipse cx="' + f(p[0] + 0.6) + '" cy="' + f(p[1] + 1) + '" rx="' + f(2.4 * o) + '" ry="' + f(3.2 * o) + '" fill="#A8142A" opacity=".5"/>' +
          '<path d="M' + f(p[0]) + ' ' + f(p[1] - 3 * o) + ' Q' + f(p[0] + 2 * o) + ' ' + f(p[1] + 1.4 * o) + ' ' + f(p[0]) + ' ' + f(p[1] + 1.8 * o) +
          ' Q' + f(p[0] - 2 * o) + ' ' + f(p[1] + 1.4 * o) + ' ' + f(p[0]) + ' ' + f(p[1] - 3 * o) + 'Z" fill="#FFD54E"/>' +
          '<circle cx="' + f(p[0] - 0.5 * o) + '" cy="' + f(p[1] - 1 * o) + '" r="' + f(0.55 * o) + '" fill="#FFF7CC"/>';
      }
    }
    var pr = donustur([[-34, -14]], T)[0];
    ek += yumusakParlama(pr[0] + 2, pr[1] + 6, 8, 15, 20, 0.3) + parlama(pr[0], pr[1], 3.4, 7, 20);
    var govde = cel(n, { rim: '#F04A58', golge: '#BE1C32', ana: '#E8313F', acik: '#FF6363' }, { as: 0.6, ek: ek });
    govde.kalin = 4.6;
    var arka = [yaprak(tepe[0], tepe[1], -38, 30, 13, -6, 'arka', 'orta'), yaprak(tepe[0], tepe[1], 40, 30, 13, 6, 'arka', 'orta')];
    var sapP = sap([tepe[0], tepe[1] + 2], [tepe[0] + 2, tepe[1] - 12], [tepe[0] + 8, tepe[1] - 26], 6,
      { rim: '#6FAE4A', golge: '#2F6E2C', ana: '#4E9A3E', acik: '#7CC062' }, '#B8E08E');
    var on = [
      yaprak(tepe[0] - 2, tepe[1] + 2, -100, 30, 13, -8, 'orta', 'orta'),
      yaprak(tepe[0] + 2, tepe[1] + 2, 100, 30, 13, 8, 'orta', 'orta'),
      yaprak(tepe[0] - 2, tepe[1] + 3, -145, 27, 12, -5, 'on', 'orta'),
      yaprak(tepe[0] + 2, tepe[1] + 3, 148, 27, 12, 5, 'on', 'orta'),
      yaprak(tepe[0], tepe[1] + 4, 180, 24, 12, 2, 'on', 'orta')
    ];
    var k = govde.kutu;
    return birlestir([govde].concat(arka, [sapP], on), { x: k.cx + 4, y: k.y1 + 3, rx: k.w * 0.34 });
  }

  // ---------- limon ----------
  function limon() {
    var yerel = [];
    for (var i = 0; i < 72; i++) {
      var t = 2 * Math.PI * i / 72;
      var r = 1 / Math.sqrt(Math.pow(Math.cos(t) / 50, 2) + Math.pow(Math.sin(t) / 64, 2));
      var d1 = Math.atan2(Math.sin(t + Math.PI / 2), Math.cos(t + Math.PI / 2)), d2 = Math.atan2(Math.sin(t - Math.PI / 2), Math.cos(t - Math.PI / 2));
      r += 9 * Math.exp(-Math.pow(d1 / 0.15, 2)) + 7 * Math.exp(-Math.pow(d2 / 0.15, 2));
      yerel.push([r * Math.cos(t), r * Math.sin(t)]);
    }
    var T = { aci: 42, olcek: 0.95, x: 95, y: 120 };
    var n = donustur(yerel, T);
    var R = rastgele(5), ek = '';
    for (var j = 0; j < 150; j++) {
      var p = donustur([[-50 + R() * 100, -64 + R() * 128]], T)[0];
      if (!icindeMi(p, n) || kenaraUzaklik(p, n) < 3) continue;
      ek += '<circle cx="' + f(p[0]) + '" cy="' + f(p[1]) + '" r="' + f(0.5 + R() * 0.6) + '" fill="' + (R() > 0.5 ? '#E0AE14' : '#FFF6B4') + '" opacity=".45"/>';
    }
    var pr = donustur([[-22, -22]], T)[0];
    ek += yumusakParlama(pr[0], pr[1] + 4, 10, 18, 42, 0.35) + parlama(pr[0] - 2, pr[1] - 2, 3.2, 8, 42);
    var govde = cel(n, { rim: '#FFD23A', golge: '#DDA212', ana: '#FFDF38', acik: '#FFF182' }, { as: 0.58, ek: ek });
    govde.kalin = 4.6;
    var up = yon(T), uc = donustur([[0, -72]], T)[0];
    var sapUc = [uc[0] + up[0] * 9, uc[1] + up[1] * 9];
    var s = sap(uc, [uc[0] + up[0] * 5, uc[1] + up[1] * 5], sapUc, 5.5, { rim: '#9AAE44', golge: '#5E6E22', ana: '#8A9C36', acik: '#B2C45A' }, '#D8E29A');
    var y = yaprak(sapUc[0], sapUc[1], -46, 46, 20, -10, 'orta', 'orta');
    var d = dugum(sapUc[0], sapUc[1], 3.2, '#6E7A2A');
    var k = govde.kutu;
    return birlestir([govde, s, y, d], { x: k.cx + 3, y: k.y1 + 2, rx: k.w * 0.36 });
  }

  // ---------- nar ----------
  function nar() {
    var C = [100, 128], yerel = [];
    for (var i = 0; i < 72; i++) {
      var t = 2 * Math.PI * i / 72, r = 1 + 0.012 * Math.cos(6 * t);
      yerel.push([Math.cos(t) * 61 * r, Math.sin(t) * 57 * r]);
    }
    var n = donustur(yerel, { x: C[0], y: C[1] });
    var ek = '';
    [-0.38, 0.32].forEach(function (u) {
      var pts = [];
      for (var k = 0; k <= 16; k++) {
        var v = -1 + 2 * k / 16, w = Math.sqrt(Math.max(0, 1 - v * v));
        pts.push([C[0] + u * 61 * w, C[1] + v * 55]);
      }
      ek += '<path d="' + yol(pts) + '" fill="none" stroke="#E86474" stroke-width="1.2" opacity=".25"/>';
    });
    ek += '<ellipse cx="' + C[0] + '" cy="' + (C[1] - 52) + '" rx="20" ry="7" fill="#7A0E20" opacity=".45" filter="url(#rmBul3)"/>';
    ek += yumusakParlama(C[0] - 26, C[1] - 22, 12, 18, 30, 0.25) + parlama(C[0] - 30, C[1] - 26, 3.6, 7.5, 30) + '<circle cx="' + (C[0] - 19) + '" cy="' + (C[1] - 38) + '" r="1.7" fill="#FFFFFF" opacity=".85"/>';
    var govde = cel(n, { rim: '#D8404F', golge: '#98142C', ana: '#C92038', acik: '#DC3349' }, { as: 0.52, ek: ek });
    govde.kalin = 4.6;

    // tac: kisa boyun + disa acilan sivri canak yapraklari
    var TX = C[0], TY = C[1] - 62;
    var boyun = cel([[TX - 14, TY + 12], [TX - 12, TY - 1], [TX + 12, TY - 1], [TX + 14, TY + 12], [TX + 7, TY + 15], [TX - 7, TY + 15]],
      { rim: '#C22F40', golge: '#7E1022', ana: '#B21E33', acik: '#D23A4C' }, { r: 0.8, d: 3, a: 6, ic: 1.3 });
    boyun.kalin = 3.8;
    function disler(arkaMi) {
      var parca = [];
      for (var j = 0; j < 6; j++) {
        var a = 2 * Math.PI * j / 6 + Math.PI / 6, arka = Math.sin(a) < 0;
        if (arka !== arkaMi) continue;
        var bx = TX + Math.cos(a) * 11, by = TY - 1 + Math.sin(a) * 3.6;
        var ucx = bx + Math.cos(a) * 8, ucy = by - 11 + Math.sin(a) * 2;
        var dk = [-Math.sin(a) * 4.8, Math.cos(a) * 1.6];
        var dis = [[bx + dk[0], by + dk[1] + 1], [bx + (ucx - bx) * 0.5 + dk[0] * 0.55, by + (ucy - by) * 0.5], [ucx, ucy],
          [bx + (ucx - bx) * 0.5 - dk[0] * 0.55, by + (ucy - by) * 0.5], [bx - dk[0], by - dk[1] + 1]];
        var d = yol(dis, true);
        parca.push({
          siluet: d, kalin: 3.2,
          svg: '<path d="' + d + '" fill="' + (arka ? '#8E1426' : '#BE2539') + '"/>' +
            '<path d="M' + f(bx) + ' ' + f(by) + ' L' + f(ucx) + ' ' + f(ucy) + '" stroke="' + (arka ? '#B02A3C' : '#E0506A') + '" stroke-width="1.1" stroke-linecap="round"/>' +
            '<path d="' + d + '" fill="none" stroke="' + IC + '" stroke-width="1.3" stroke-linejoin="round"/>'
        });
      }
      return parca;
    }
    var ic = { siluet: null, svg: '<ellipse cx="' + TX + '" cy="' + (TY - 1) + '" rx="10.5" ry="3.6" fill="#4A0A14" stroke="' + IC + '" stroke-width="1.2"/>' +
      '<path d="M' + (TX - 5) + ' ' + (TY - 1.5) + ' l1.6 -3.5 l1.6 3.5 l1.6 -4.2 l1.6 4.2 l1.6 -3.5" fill="none" stroke="#E6B866" stroke-width="1"/>' };
    return birlestir([govde, boyun].concat(disler(true), [ic], disler(false)), { x: C[0] + 4, y: C[1] + 59, rx: 50 });
  }

  // ---------- seftali ----------
  function seftali() {
    var C = [100, 126], yerel = [];
    for (var i = 0; i < 80; i++) {
      var t = 2 * Math.PI * i / 80, d = Math.atan2(Math.sin(t + Math.PI / 2), Math.cos(t + Math.PI / 2));
      var r = 1 + 0.03 * Math.sin(2 * t) - 0.1 * Math.exp(-Math.pow(d / 0.24, 2));
      yerel.push([Math.cos(t) * 61 * r, Math.sin(t) * 57 * r]);
    }
    var n = donustur(yerel, { x: C[0], y: C[1] });
    var ek = '<ellipse cx="' + (C[0] + 24) + '" cy="' + (C[1] - 10) + '" rx="42" ry="48" fill="#F2545B" opacity=".55" filter="url(#rmBul10)"/>' +
      '<ellipse cx="' + (C[0] + 32) + '" cy="' + (C[1] - 4) + '" rx="22" ry="28" fill="#E23A4A" opacity=".35" filter="url(#rmBul6)"/>';
    // oluk: tepeden asagi kivrilan cizgi
    var oluk = [[C[0] - 1, C[1] - 49], [C[0] - 9, C[1] - 28], [C[0] - 13, C[1]], [C[0] - 10, C[1] + 28], [C[0] - 2, C[1] + 47]];
    ek += '<path d="' + yol(oluk) + '" fill="none" stroke="#D9664A" stroke-width="2.4" stroke-linecap="round" opacity=".8"/>' +
      '<path d="' + yol(oluk.map(function (p) { return [p[0] + 2.4, p[1]]; })) + '" fill="none" stroke="#FFD2A6" stroke-width="1.4" stroke-linecap="round" opacity=".8"/>';
    ek += yumusakParlama(C[0] - 30, C[1] - 20, 14, 18, 25, 0.38) + '<circle cx="' + (C[0] - 34) + '" cy="' + (C[1] - 30) + '" r="2.6" fill="#FFFFFF" opacity=".7"/>';
    var govde = cel(n, { rim: '#FF9A6C', golge: '#E0704C', ana: '#FFB27A', acik: '#FFD29C' }, { as: 0.6, ek: ek });
    govde.kalin = 4.6;
    var dip = [C[0] - 1, C[1] - 50];
    var sapUc = [dip[0] + 3, dip[1] - 12];
    var s = sap(dip, [dip[0], dip[1] - 6], sapUc, 5.5);
    var y1 = yaprak(sapUc[0], sapUc[1], 62, 44, 19, 10, 'orta', 'orta');
    var y2 = yaprak(sapUc[0], sapUc[1], -38, 34, 15, -8, 'on', 'orta');
    var d = dugum(sapUc[0], sapUc[1], 3.4);
    return birlestir([govde, s, y1, y2, d], { x: C[0] + 4, y: C[1] + 58, rx: 50 });
  }

  var MEYVELER = {
    muz: muz, karpuz: karpuz, ananas: ananas, mango: mango, uzum: uzum,
    kivi: kivi, cilek: cilek, limon: limon, nar: nar, seftali: seftali
  };


  // ======================================================================
  //                       POWER-UP'LAR VE ENGELLER
  // ======================================================================

  // Ozel taslarin arkasindaki yumusak isik: tahtada hemen fark edilsinler
  function hale(renk, guc, r) {
    var id = yeniId('h');
    ekDefs += '<radialGradient id="' + id + '"><stop offset="0" stop-color="' + renk + '" stop-opacity="' + guc + '"/><stop offset=".6" stop-color="' + renk + '" stop-opacity="' + (guc * 0.45).toFixed(2) + '"/><stop offset="1" stop-color="' + renk + '" stop-opacity="0"/></radialGradient>';
    return '<circle cx="100" cy="104" r="' + (r || 98) + '" fill="url(#' + id + ')"/>';
  }

  var TURKUAZ = { rim: '#63D3CA', golge: '#136F6D', ana: '#1F9F9B', acik: '#5FD1C7' };

  // Roket (yatay): meyvenin arkasindan gecen iki uclu ok. Dikey roket icin 90 derece dondurulur.
  function roket() {
    var cubuk = cel([[48, 92], [152, 92], [152, 118], [48, 118]], TURKUAZ, { koseli: true, r: 1, d: 4, a: 9 });
    cubuk.kalin = 4.4;
    var sol = cel([[6, 105], [54, 68], [54, 142]], TURKUAZ, { koseli: true, r: 1.2, d: 6, a: 14 });
    var sag = cel([[194, 105], [146, 68], [146, 142]], TURKUAZ, { koseli: true, r: 1.2, d: 6, a: 14 });
    sol.kalin = sag.kalin = 4.4;
    var cizgiler = { siluet: null, svg:
      '<path d="M24 105 L44 90 M24 105 L44 120" stroke="#E6FFFB" stroke-width="3" stroke-linecap="round" opacity=".8"/>' +
      '<path d="M176 105 L156 90 M176 105 L156 120" stroke="#E6FFFB" stroke-width="3" stroke-linecap="round" opacity=".8"/>' +
      '<path d="M58 99 H142" stroke="#C8FFF8" stroke-width="3" stroke-linecap="round" opacity=".7"/>' };
    return hale('#FFF2C0', 0.95) + birlestir([cubuk, sol, sag, cizgiler]);
  }

  // Bomba: fitili yanan koyu bomba, meyve on yuzundeki krem etikette
  function bomba() {
    var C = [100, 116], R = 68;
    var govde = cel(elips(C[0], C[1], R, R, 48, 0), { rim: '#5A5480', golge: '#14121D', ana: '#2B283F', acik: '#46426A' }, {
      as: 0.55,
      ek: yumusakParlama(C[0] - 30, C[1] - 32, 16, 10, -40, 0.35) + parlama(C[0] - 36, C[1] - 40, 7, 3.5, -40, 0.85) +
        '<circle cx="' + (C[0] - 20) + '" cy="' + (C[1] - 52) + '" r="2.4" fill="#FFFFFF" opacity=".8"/>'
    });
    govde.kalin = 4.6;
    var u = [Math.cos(-52 * Math.PI / 180), Math.sin(-52 * Math.PI / 180)], v = [-u[1], u[0]];
    var c = [C[0] + u[0] * (R + 2), C[1] + u[1] * (R + 2)];
    function kap(a, b) { return [c[0] + v[0] * a + u[0] * b, c[1] + v[1] * a + u[1] * b]; }
    var kapak = cel([kap(-13, -6), kap(13, -6), kap(12, 9), kap(-12, 9)], { rim: '#C3C7D4', golge: '#555A6C', ana: '#8A8FA3', acik: '#D2D6E0' }, { koseli: true, r: 0.8, d: 3, a: 6, ic: 1.3 });
    kapak.kalin = 3.8;
    var fitilBas = kap(0, 10), fitil = [];
    for (var i = 0; i <= 16; i++) {
      var t = i / 16, q = 1 - t;
      fitil.push([q * q * fitilBas[0] + 2 * q * t * 172 + t * t * 166, q * q * fitilBas[1] + 2 * q * t * 44 + t * t * 18]);
    }
    var fy = yol(fitil);
    var kivilcim = '';
    (function () {
      var x = 166, y = 18, dis = '', ic2 = '';
      for (var k = 0; k < 20; k++) {
        var a = Math.PI * k / 10, r1 = k % 2 ? 6 : 15, r2 = k % 2 ? 2.6 : 8;
        dis += (k ? 'L' : 'M') + f(x + r1 * Math.cos(a)) + ' ' + f(y + r1 * Math.sin(a));
        ic2 += (k ? 'L' : 'M') + f(x + r2 * Math.cos(a + 0.15)) + ' ' + f(y + r2 * Math.sin(a + 0.15));
      }
      kivilcim = '<circle cx="' + x + '" cy="' + y + '" r="14" fill="#FFB02E" opacity=".45" filter="url(#rmBul4)"/>' +
        '<path d="' + dis + 'Z" fill="#FFC93C" stroke="' + K + '" stroke-width="2" stroke-linejoin="round"/>' +
        '<path d="' + ic2 + 'Z" fill="#FFF6C8"/>';
    })();
    var fitilParca = { siluet: null, svg:
      '<path d="' + fy + '" fill="none" stroke="' + K + '" stroke-width="8" stroke-linecap="round"/>' +
      '<path d="' + fy + '" fill="none" stroke="#9A7446" stroke-width="4.6" stroke-linecap="round"/>' +
      '<path d="' + fy + '" fill="none" stroke="#D2A86E" stroke-width="1.6" stroke-dasharray="3 4" stroke-linecap="round"/>' + kivilcim };
    var etiket = cel(elips(C[0], C[1] + 4, 45, 45, 40, 0), { rim: '#F3E6CC', golge: '#DCC8A4', ana: '#FFF4DC', acik: '#FFFBEF' }, {
      as: 0.6, r: 1, d: 4, a: 8, ic: 1.8,
      ek: '<circle cx="' + C[0] + '" cy="' + (C[1] + 4) + '" r="39" fill="none" stroke="#E6D3AE" stroke-width="2.4"/>'
    });
    return hale('#FFD9A0', 0.8) + birlestir([govde, kapak, fitilParca, { siluet: null, svg: etiket.svg }], { x: 104, y: 188, rx: 50 });
  }

  // Gunes: Ruma'nin 70'ler gunes yuzu. Renk tasimaz; bir meyveyle yer degistirince o meyvenin hepsini temizler.
  function gunes() {
    var M = [100, 104];
    var TONLAR = [
      { dip: '#D2560A', orta: '#F47B20', uc: '#FF9E4A', golge: '#A8420A', damar: '#FFC592', parlak: '#FFD9B5' },
      { dip: '#CF4C73', orta: '#F2789A', uc: '#FFA3BD', golge: '#A63257', damar: '#FFC6D5', parlak: '#FFDCE6' },
      { dip: '#0F7F7C', orta: '#22A7A0', uc: '#52CBC2', golge: '#0A5956', damar: '#94E6DE', parlak: '#BDF3ED' }
    ];
    var isinlar = [];
    for (var i = 0; i < 12; i++) {
      var a = i * 30, r = a * Math.PI / 180;
      isinlar.push(yaprak(M[0] + 40 * Math.sin(r), M[1] - 40 * Math.cos(r), a, 50, 25, 9, TONLAR[i % 3], 'mizrak'));
    }
    var yuz =
      '<circle cx="' + M[0] + '" cy="' + M[1] + '" r="42" fill="none" stroke="#F3A21E" stroke-width="2.4" opacity=".7"/>' +
      '<path d="M71 101 Q80 110 89 101" fill="none" stroke="' + K + '" stroke-width="4" stroke-linecap="round"/>' +
      '<path d="M111 101 Q120 110 129 101" fill="none" stroke="' + K + '" stroke-width="4" stroke-linecap="round"/>' +
      '<path d="M69 96 l-4 -4 M73 94 l-2 -5 M131 96 l4 -4 M127 94 l2 -5" stroke="' + K + '" stroke-width="2.2" stroke-linecap="round"/>' +
      '<path d="M87 120 Q100 132 113 120" fill="none" stroke="' + K + '" stroke-width="4" stroke-linecap="round"/>' +
      '<ellipse cx="68" cy="116" rx="9" ry="5.5" fill="#FF7F95" opacity=".55"/><ellipse cx="132" cy="116" rx="9" ry="5.5" fill="#FF7F95" opacity=".55"/>' +
      parlama(72, 74, 7, 4, -35, 0.85);
    var disk = cel(elips(M[0], M[1], 52, 52, 48, 0), { rim: '#FFD560', golge: '#E0880E', ana: '#FFC233', acik: '#FFE27A' }, { as: 0.62, ek: yuz });
    disk.kalin = 4.6;
    return hale('#FFE7A0', 0.95) + birlestir(isinlar.concat([disk]));
  }

  // Buz: tasin ustunde yari saydam buz blogu. kat=2 daha kalin ve kiragili.
  function buz(kat) {
    var yogun = kat === 2, n = [];
    for (var i = 0; i < 72; i++) {
      var t = 2 * Math.PI * i / 72, c = Math.cos(t), sn = Math.sin(t);
      // yuvarlak koseli kare + hafif dalgali kenar (el yapimi buz hissi)
      var x = Math.sign(c) * Math.pow(Math.abs(c), 0.28), y = Math.sign(sn) * Math.pow(Math.abs(sn), 0.28);
      var w = 1 + 0.012 * Math.sin(5 * t + 1) + 0.009 * Math.sin(11 * t);
      n.push([100 + 88 * x * w, 100 + 88 * y * w]);
    }
    var d = yol(n, true), id = yeniId('k');
    ekDefs += '<clipPath id="' + id + '"><path d="' + d + '"/></clipPath>';
    var R = rastgele(yogun ? 21 : 9), kirag = '';
    if (yogun) {
      for (var k = 0; k < 90; k++) {
        var px = 16 + R() * 168, py = 16 + R() * 168;
        if (Math.hypot(px - 100, py - 100) < 58) continue;
        kirag += '<circle cx="' + f(px) + '" cy="' + f(py) + '" r="' + f(0.8 + R() * 1.6) + '" fill="#FFFFFF" opacity="' + f(0.35 + R() * 0.4) + '"/>';
      }
    }
    var kristal = function (x, y, r) {
      var s2 = '';
      for (var j = 0; j < 3; j++) {
        var a = j * 60 * Math.PI / 180, dx = Math.cos(a) * r, dy = Math.sin(a) * r;
        s2 += '<path d="M' + f(x - dx) + ' ' + f(y - dy) + ' L' + f(x + dx) + ' ' + f(y + dy) + '" stroke="#FFFFFF" stroke-width="2.2" stroke-linecap="round" opacity=".9"/>';
      }
      return s2;
    };
    // Kalin buz iki katli gorunur: icte ikinci bir buz cercevesi ve koselerde yogun kiragi.
    // Bir vurus yiyince ince buza (kat=1) doner; fark uzaktan da secilmeli ama meyve gorunur kalmali.
    var ic2 = yogun ? '<path d="' + d + '" transform="translate(100 100) scale(.78) translate(-100 -100)" fill="none" stroke="#FFFFFF" stroke-width="7" opacity=".85"/>' +
      '<path d="' + d + '" transform="translate(100 100) scale(.78) translate(-100 -100)" fill="none" stroke="#5FAED3" stroke-width="3"/>' : '';
    var kose = yogun ? [[22, 22], [178, 22], [22, 178], [178, 178]].map(function (k) {
      return '<circle cx="' + k[0] + '" cy="' + k[1] + '" r="30" fill="#FFFFFF" opacity=".55"/>';
    }).join('') : '';
    return '<path d="' + d + '" fill="' + (yogun ? '#9FD8F0' : '#CDEFFB') + '" opacity="' + (yogun ? 0.62 : 0.42) + '"/>' +
      '<g clip-path="url(#' + id + ')">' +
        kose +
        // sol-ust kenarda parlak, sag-altta koyu pah
        '<path d="' + d + '" transform="translate(5 5)" fill="none" stroke="#F4FDFF" stroke-width="' + (yogun ? 14 : 9) + '" opacity=".85"/>' +
        '<path d="' + d + '" transform="translate(-5 -5)" fill="none" stroke="#6FB9D8" stroke-width="' + (yogun ? 14 : 9) + '" opacity=".75"/>' +
        '<path d="M26 78 L78 26" stroke="#FFFFFF" stroke-width="9" stroke-linecap="round" opacity=".6"/>' +
        '<path d="M28 104 L104 28" stroke="#FFFFFF" stroke-width="3.5" stroke-linecap="round" opacity=".5"/>' +
        '<path d="M150 178 L178 150" stroke="#FFFFFF" stroke-width="4" stroke-linecap="round" opacity=".4"/>' +
        '<circle cx="152" cy="58" r="3" fill="#FFFFFF" opacity=".7"/><circle cx="162" cy="70" r="1.8" fill="#FFFFFF" opacity=".6"/>' +
        kirag + ic2 + (yogun ? kristal(34, 166, 15) + kristal(166, 34, 15) + kristal(166, 166, 10) + kristal(34, 34, 10) : '') +
      '</g>' +
      '<path d="' + d + '" fill="none" stroke="' + (yogun ? '#2F7FA8' : '#4E9EC4') + '" stroke-width="' + (yogun ? 6 : 3.4) + '"/>';
  }

  // Kutu: Ruma'nin kraft kutusu. kat=2 sicimle bagli, kirmak icin iki vurus gerekir.
  function kutuCiz(kat) {
    var on = cel([[18, 52], [172, 52], [172, 186], [18, 186]], { rim: '#D9B07A', golge: '#96683A', ana: '#C9985F', acik: '#D8AE76' }, {
      koseli: true, r: 1.5, d: 8, a: 60,
      ek: '<path d="M26 78 H164 M26 104 H164 M26 130 H164 M26 156 H164" stroke="#B4854F" stroke-width="1.2" opacity=".45"/>'
    });
    on.kalin = 4.6;
    var ust = cel([[18, 52], [42, 22], [196, 22], [172, 52]], { rim: '#E8C895', golge: '#D5AD74', ana: '#E4BF88', acik: '#F0D3A2' }, { koseli: true, r: 1, d: 3, a: 10, ic: 1.4 });
    ust.kalin = 4.6;
    var yan = cel([[172, 52], [196, 22], [196, 158], [172, 186]], { rim: '#B08250', golge: '#7C5429', ana: '#A1733F', acik: null }, { koseli: true, r: 1, d: 3, ic: 1.4 });
    yan.kalin = 4.6;
    var ek = '';
    if (kat === 2) {
      var sicim = function (d) {
        return '<path d="' + d + '" fill="none" stroke="' + K + '" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="' + d + '" fill="none" stroke="#7A5230" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="' + d + '" fill="none" stroke="#B08658" stroke-width="1" stroke-dasharray="2 3"/>';
      };
      ek += sicim('M95 186 V52 L119 22') + sicim('M18 119 H172 L196 89') + sicim('M30 37 H184');
      ek += '<ellipse cx="96" cy="33" rx="13" ry="7" transform="rotate(-20 96 33)" fill="none" stroke="' + K + '" stroke-width="6"/>' +
        '<ellipse cx="96" cy="33" rx="13" ry="7" transform="rotate(-20 96 33)" fill="none" stroke="#7A5230" stroke-width="3"/>' +
        '<ellipse cx="124" cy="31" rx="13" ry="7" transform="rotate(20 124 31)" fill="none" stroke="' + K + '" stroke-width="6"/>' +
        '<ellipse cx="124" cy="31" rx="13" ry="7" transform="rotate(20 124 31)" fill="none" stroke="#7A5230" stroke-width="3"/>' +
        '<circle cx="110" cy="36" r="5.5" fill="#7A5230" stroke="' + K + '" stroke-width="2"/>';
    } else {
      ek += '<path d="M84 52 L108 22 L128 22 L104 52 Z" fill="#F1E0BE" stroke="' + IC + '" stroke-width="1.2" stroke-linejoin="round"/>' +
        '<path d="M84 52 H104 V104 L99 100 L94 105 L89 100 L84 104 Z" fill="#F1E0BE" stroke="' + IC + '" stroke-width="1.2" stroke-linejoin="round"/>';
    }
    ek += '<g transform="rotate(-12 56 152)" opacity=".75"><circle cx="56" cy="152" r="21" fill="none" stroke="#8A3B2A" stroke-width="2.4"/>' +
      '<circle cx="56" cy="152" r="16.5" fill="none" stroke="#8A3B2A" stroke-width="1"/>' +
      '<text x="56" y="157" text-anchor="middle" font-family="Georgia, \'Times New Roman\', serif" font-style="italic" font-size="14" fill="#8A3B2A">ruma</text></g>';
    return birlestir([yan, ust, on, { siluet: null, svg: ek }]);
  }

  // Sarmasik: tasin ustune dolanan yaprakli dal. Tas yerinden oynamaz.
  function sarmasik() {
    var dal = kubik([[8, 150], [44, 120], [72, 150], [104, 124], [136, 98], [148, 74], [192, 60]], 12);
    var d = yol(dal);
    var s = '<path d="' + d + '" fill="none" stroke="' + K + '" stroke-width="12" stroke-linecap="round"/>' +
      '<path d="' + d + '" fill="none" stroke="#347A33" stroke-width="7.5" stroke-linecap="round"/>' +
      '<path d="' + yol(dal.map(function (p) { return [p[0] - 1, p[1] - 1.6]; })) + '" fill="none" stroke="#72BE5E" stroke-width="2.4" stroke-linecap="round"/>';
    var fil = [];
    for (var i = 0; i <= 30; i++) {
      var t = i / 30 * 3 * Math.PI, r = 10 * (1 - t / (3.6 * Math.PI));
      fil.push([150 + r * Math.cos(t + Math.PI * 0.9), 110 + r * Math.sin(t + Math.PI * 0.9)]);
    }
    fil.unshift([140, 94]);
    s += '<path d="' + yol(fil) + '" fill="none" stroke="' + K + '" stroke-width="5" stroke-linecap="round"/>' +
      '<path d="' + yol(fil) + '" fill="none" stroke="#6FAE4A" stroke-width="2.2" stroke-linecap="round"/>';
    var yapraklar = [
      yaprak(28, 134, -30, 30, 17, -6, 'orta', 'orta'), yaprak(64, 140, 150, 28, 16, 6, 'on', 'orta'),
      yaprak(100, 127, -20, 30, 17, -5, 'orta', 'orta'), yaprak(128, 108, 140, 28, 16, 6, 'on', 'orta'),
      yaprak(164, 67, -40, 26, 15, -6, 'orta', 'orta')
    ];
    return s + birlestir(yapraklar);
  }
  // Ruma Coin: altin sikke, ortasinda kabartma "r"
  function coin() {
    var dis = cel(elips(100, 100, 82, 82, 48, 0), { rim: '#FFD76A', golge: '#C9800E', ana: '#F6B82E', acik: '#FFD75C' }, {
      as: 0.62,
      ek: '<circle cx="100" cy="100" r="62" fill="none" stroke="#D99316" stroke-width="7"/>' +
        '<circle cx="100" cy="100" r="62" fill="none" stroke="#FFE7A0" stroke-width="2.4" transform="translate(-2 -2)"/>' +
        '<text x="100" y="131" text-anchor="middle" font-family="Fraunces, Georgia, serif" font-weight="800" font-size="92" fill="#C77E10">r</text>' +
        '<text x="97" y="128" text-anchor="middle" font-family="Fraunces, Georgia, serif" font-weight="800" font-size="92" fill="#FFE9A8">r</text>' +
        parlama(62, 58, 12, 6, -40, 0.85)
    });
    dis.kalin = 5;
    return birlestir([dis]);
  }

  // ======================================================================

  var sprite = null;
  function uret() {
    if (sprite) return sprite;
    var semboller = '';
    Object.keys(MEYVELER).forEach(function (ad) {
      semboller += '<symbol id="rm-m-' + ad + '" viewBox="0 0 200 200">' + MEYVELER[ad]() + '</symbol>';
    });
    var diger = {
      'rm-o-roket': roket, 'rm-o-bomba': bomba, 'rm-o-gunes': gunes,
      'rm-e-buz1': function () { return buz(1); }, 'rm-e-buz2': function () { return buz(2); },
      'rm-e-kutu1': function () { return kutuCiz(1); }, 'rm-e-kutu2': function () { return kutuCiz(2); },
      'rm-e-sarmasik': sarmasik, 'rm-coin': coin
    };
    Object.keys(diger).forEach(function (id) {
      semboller += '<symbol id="' + id + '" viewBox="0 0 200 200" overflow="visible">' + diger[id]() + '</symbol>';
    });
    var filtreler = [1, 3, 4, 6, 8, 10].map(function (b) {
      return '<filter id="rmBul' + b + '" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="' + b + '"/></filter>';
    }).join('');
    sprite = '<svg id="rm-sprite" xmlns="http://www.w3.org/2000/svg" style="position:absolute;width:0;height:0;overflow:hidden" aria-hidden="true"><defs>' +
      filtreler + ekDefs + '</defs>' + semboller + '</svg>';
    return sprite;
  }

  function yukle() {
    if (document.getElementById('rm-sprite')) return;
    var d = document.createElement('div');
    d.innerHTML = uret();
    document.body.insertBefore(d.firstChild, document.body.firstChild);
  }

  function meyve(ad) {
    return '<svg viewBox="0 0 200 200" aria-hidden="true"><use href="#rm-m-' + ad + '"/></svg>';
  }

  // Tahtadaki tas: meyve + power-up. o: null | 'y' (yatay roket) | 'd' (dikey roket) | 'b' (bomba) | 'g' (gunes)
  function tas(ad, o) {
    var m = '<use href="#rm-m-' + ad + '"/>', ic;
    if (o === 'g') ic = '<use href="#rm-o-gunes"/>';
    else if (o === 'y' || o === 'd') {
      ic = '<g' + (o === 'd' ? ' transform="rotate(90 100 105)"' : '') + '><use href="#rm-o-roket"/></g>' +
        '<g transform="translate(100 108) scale(.74) translate(-100 -108)">' + m + '</g>';
    } else if (o === 'b') {
      ic = '<use href="#rm-o-bomba"/><g transform="translate(100 121) scale(.5) translate(-100 -108)">' + m + '</g>';
    } else ic = m;
    return '<svg viewBox="0 0 200 200" overflow="visible" aria-hidden="true">' + ic + '</svg>';
  }

  // Engel: 'buz1' | 'buz2' | 'kutu1' | 'kutu2' | 'sarmasik'
  function engel(ad) {
    return '<svg viewBox="0 0 200 200" overflow="visible" aria-hidden="true"><use href="#rm-e-' + ad + '"/></svg>';
  }

  // Atlas icin: bir tasin <svg> sarmalayicisi olmadan ic isaretlemesi
  function tasIc(ad, o) { return tas(ad, o).replace(/^<svg[^>]*>/, '').replace(/<\/svg>$/, ''); }
  function engelIc(ad) { return '<use href="#rm-e-' + ad + '"/>'; }
  // Sprite'in ic kismi (defs + semboller): tek bir SVG goruntusu icine gomulebilir
  function spriteIc() { return uret().replace(/^<svg[^>]*>/, '').replace(/<\/svg>$/, ''); }
  function ikon(id, sinif) {
    return '<svg class="' + (sinif || '') + '" viewBox="0 0 200 200" overflow="visible" aria-hidden="true"><use href="#' + id + '"/></svg>';
  }

  kok.RumaMatchCizim = {
    yukle: yukle, meyve: meyve, tas: tas, engel: engel, uret: uret, tasIc: tasIc, engelIc: engelIc, spriteIc: spriteIc, ikon: ikon,
    meyveler: Object.keys(MEYVELER),
    // patlarken sacilan meyve suyu rengi
    sular: { muz: '#FFD23F', karpuz: '#F04B45', ananas: '#F6B232', mango: '#FF8C2E', uzum: '#8E4FC9', kivi: '#7FC23E', cilek: '#E8313F', limon: '#FFE03A', nar: '#C92038', seftali: '#FFA77A' }
  };
})(typeof self !== 'undefined' ? self : this);
